import { Directive, ElementRef, HostListener, Input, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '../../providers/nav-controller';
import { IonRouterOutlet } from './ion-router-outlet';
var IonBackButton = /** @class */ (function () {
    function IonBackButton(router, routerOutlet, navCtrl, elementRef) {
        this.router = router;
        this.routerOutlet = routerOutlet;
        this.navCtrl = navCtrl;
        this.elementRef = elementRef;
    }
    Object.defineProperty(IonBackButton.prototype, "defaultHref", {
        get: function () {
            return this.elementRef.nativeElement.defaultHref;
        },
        set: function (value) {
            this.elementRef.nativeElement.defaultHref = value;
        },
        enumerable: true,
        configurable: true
    });
    IonBackButton.prototype.onClick = function (ev) {
        if (this.routerOutlet && this.routerOutlet.canGoBack()) {
            this.routerOutlet.pop();
            ev.preventDefault();
        }
        else if (this.router && this.defaultHref != null) {
            this.navCtrl.setIntent(2 /* Back */);
            this.router.navigateByUrl(this.defaultHref);
            ev.preventDefault();
        }
    };
    IonBackButton.decorators = [
        { type: Directive, args: [{
                    selector: 'ion-back-button'
                },] },
    ];
    /** @nocollapse */
    IonBackButton.ctorParameters = function () { return [
        { type: Router, decorators: [{ type: Optional }] },
        { type: IonRouterOutlet, decorators: [{ type: Optional }] },
        { type: NavController },
        { type: ElementRef }
    ]; };
    IonBackButton.propDecorators = {
        defaultHref: [{ type: Input }],
        onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
    };
    return IonBackButton;
}());
export { IonBackButton };
